import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M13.595 16.148v-2.812c0-1.553-1.284-2.813-2.87-2.813H4.3c-1.585 0-2.87 1.26-2.87 2.813v2.812m17.142 0v-2.812c0-1.553-1.284-2.812-2.87-2.812M13.043 1.7a2.79 2.79 0 0 1 1.162 2.26 2.79 2.79 0 0 1-1.162 2.26m-2.6-2.26c0 1.553-1.285 2.812-2.87 2.812s-2.87-1.259-2.87-2.812 1.285-2.813 2.87-2.813 2.87 1.26 2.87 2.813"
    }, null, -1)
  ]))]))
}
export default { render: render }